export const containerWidths = {
    xs:"0px",
    sm :"576px",
    md :"768px",
    lg :"992px",
    xl :"1200px",
    xxl :"1400px",
} as const;